<ng-container *ngIf="!item.hidden">

    <div class="group-title " [ngClass]="item.classes">
        <span style=" font-weight: bold;" [translate]="item.translate">{{(item.translate | translate) || item.title}}</span>
    </div>

    <div class="group-items">
        <ng-container *ngFor="let item of item.children">
            <fuse-nav-vertical-group *ngIf="item.type=='group'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-group>
            <fuse-nav-vertical-collapsable *ngIf="item.type=='collapsable'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-collapsable>
            <fuse-nav-vertical-item *ngIf="item.type=='item'" [item]="item" [attr.data-test-id]="item.id"></fuse-nav-vertical-item>
        </ng-container>
    </div>

</ng-container>
